module.exports = __webpack_public_path__ + "static/img/member_ten_discount.66146acb.png";